import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=79a5f9a2&scoped=true&"
import script from "./Wizard.vue?vue&type=script&lang=js&"
export * from "./Wizard.vue?vue&type=script&lang=js&"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=79a5f9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a5f9a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a5f9a2')) {
      api.createRecord('79a5f9a2', component.options)
    } else {
      api.reload('79a5f9a2', component.options)
    }
    module.hot.accept("./Wizard.vue?vue&type=template&id=79a5f9a2&scoped=true&", function () {
      api.rerender('79a5f9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/Wizard.vue"
export default component.exports